export default {
    automation: 1,
    collateralBuilder: 3,
    sms: 4,
    premiumSupport: 5
};